const STEPS = [
  {
    n: "01",
    title: "Real-world fit experiences",
    text: "Shoppers contribute how shoes actually fit — across brands and models.",
  },
  {
    n: "02",
    title: "Similar sizing profiles",
    text: "We identify people whose sizing patterns are similar to yours.",
  },
  {
    n: "03",
    title: "Size recommendation",
    text: "Real-world patterns inform a recommendation for the shoe you're considering.",
  },
  {
    n: "04",
    title: "Fit feedback",
    text: "After trying the shoe, shoppers can share whether the recommendation worked.",
  },
  {
    n: "05",
    title: "Better fit intelligence",
    text: "Each new fit experience contributes to the shared fit knowledge.",
  },
];

const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="section-pad border-t border-[var(--line)]">
    <div className="container-x">
      <p className="eyebrow mb-6">How It Works</p>
      <div className="max-w-2xl">
        <h2 className="font-display text-4xl leading-[1.1] tracking-tight sm:text-5xl">
          A more intuitive approach to fit.
        </h2>
        <p className="mt-6 text-base leading-relaxed text-[var(--ink-soft)]">
          Intuitive Shoes learns from real-world fit records contributed by
          shoppers. As more fit experiences are collected, the system can build
          better knowledge about how sizes actually fit across brands and models.
        </p>
      </div>

      <ol
        data-testid="how-it-works-steps"
        className="card-line mt-14 grid gap-px overflow-hidden rounded-md md:grid-cols-3 lg:grid-cols-5"
      >
        {STEPS.map((step) => (
          <li
            key={step.n}
            data-testid={`how-step-${step.n}`}
            className="border-[var(--line)] bg-[var(--cream)] p-7 md:border-l md:first:border-l-0"
          >
            <span className="text-xs tracking-[0.2em] text-[var(--rust)]">{step.n}</span>
            <h3 className="font-display mt-4 text-lg leading-snug">{step.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-[var(--ink-soft)]">{step.text}</p>
          </li>
        ))}
      </ol>

      <p className="mt-8 text-sm italic text-[var(--ink-soft)]">
        A loop, not a one-off lookup — new fit experiences contribute back to the shared knowledge.
      </p>
    </div>
  </section>
);

export default HowItWorks;
